// extracted by mini-css-extract-plugin
export default {"footerLink":"c-e_cS"};